import type { IframePoolShippingItem } from '../../../../modules/api';
import { ShippingItemCard } from '../../shared';

export interface ItemsSectionProps {
  items: IframePoolShippingItem[];
}

/**
 * Read-only Shipping List for an existing delivery — same grid + tile
 * shape as the New-page list, no edit affordance, no subtitle.
 * Figma 361:132067.
 */
export function ItemsSection({ items }: ItemsSectionProps) {
  return (
    <section>
      <h3
        className="text-[17px] font-bold tracking-[-0.3px]"
        style={{ color: 'var(--co-MyPacksItemCard-titleColor, #FFFFFF)' }}
      >
        Shipping List
      </h3>

      {items.length === 0 ? (
        <p
          className="mt-3 text-[14px]"
          style={{ color: 'rgba(255,255,255,0.55)' }}
        >
          No items attached to this delivery.
        </p>
      ) : (
        <ul className="mt-3 grid grid-cols-2 gap-3 @[600px]:grid-cols-3">
          {items.map((it) => (
            <li key={it.id}>
              <ShippingItemCard imageUrl={it.imageUrl} title={it.title} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
